import React, { useState, useEffect, useRef } from 'react';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';

const Timer = ({ maxTimeInSeconds, onComplete, isRunning }) => {
    const [displayTime, setDisplayTime] = useState(0);
    const startTimeRef = useRef(null);
    const intervalRef = useRef(null);

    useEffect(() => {
        if (isRunning && !startTimeRef.current) {
            startTimeRef.current = Date.now();
        }

        if (isRunning) {
            intervalRef.current = setInterval(() => {
                if (startTimeRef.current) {
                    const elapsed = Math.floor((Date.now() - startTimeRef.current) / 1000);
                    setDisplayTime(elapsed);
                    // Le timer continue même après maxTimeInSeconds - pas d'arrêt automatique
                }
            }, 1000);
        } else {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        }

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [isRunning]);

    // Reset timer when maxTimeInSeconds changes (new section)
    useEffect(() => {
        startTimeRef.current = isRunning ? Date.now() : null;
        setDisplayTime(0);
    }, [maxTimeInSeconds, isRunning]);

    const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    return (
        <div className="timer-container" style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px'
        }}>
            <CountdownCircleTimer
                isPlaying={isRunning}
                duration={maxTimeInSeconds}
                colors={
                    displayTime > maxTimeInSeconds
                        ? ['#FF0000'] // Rouge fixe quand on dépasse le temps
                        : ['#00FF00', '#F7B801', '#A30000', '#A30000']
                }
                colorsTime={
                    displayTime > maxTimeInSeconds
                        ? [0] // Pas de transition quand dépassé
                        : [maxTimeInSeconds * 0.7, maxTimeInSeconds * 0.3, maxTimeInSeconds * 0.1, 0]
                }
                size={80}
                strokeWidth={6}
                key={`${maxTimeInSeconds}-${displayTime > maxTimeInSeconds ? 'over' : 'normal'}`}
                onComplete={() => {
                    // Ne pas appeler onComplete - le timer continue à tourner
                    // Le cercle reste rouge et le temps continue à s'incrémenter
                    return { shouldRepeat: false };
                }}
            >
                {({ remainingTime }) => (
                    <div className="timer" style={{ textAlign: 'center', color: 'white' }}>
                        <div style={{ fontSize: '12px', color: '#aaa' }}>
                            Max: {formatTime(maxTimeInSeconds)}
                        </div>
                        <div style={{
                            fontSize: '20px',
                            fontWeight: 'bold',
                            color: displayTime > maxTimeInSeconds ? '#FF0000' : 'white'
                        }}>
                            {formatTime(displayTime)}
                        </div>
                        {displayTime > maxTimeInSeconds && (
                            <div style={{ fontSize: '10px', color: '#FF0000', marginTop: '2px' }}>
                                DÉPASSÉ !
                            </div>
                        )}
                    </div>
                )}
            </CountdownCircleTimer>
        </div>
    );
};

export default Timer;
